import { Row, Space } from "@stenajs-webui/core";
import {
  ActionMenu,
  ActionMenuItem,
  FlatButton,
  stenaDots,
} from "@stenajs-webui/elements";
import * as React from "react";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { rateSheetTableActions } from "../actions";
import { EditRateRowButton } from "../edit-rate-row/component/EditRateRowButton";
import { RateSheetTableRowState } from "../reducer";
import { rateSheetStandardTableWrapperActions } from "../redux";
import { Popover } from "@stenajs-webui/tooltip";

interface Props {
  currencyLabel?: string;
  routeAgreementId: string;
  routeAgreementPriceId: string;
  rateSheetTableRowState: RateSheetTableRowState;
  editableRouteAgreement: boolean;
  disableStatBoxes?: boolean;
}

export const RateSheetActionButtons: React.FC<Props> = ({
  routeAgreementId,
  routeAgreementPriceId,
  rateSheetTableRowState,
  currencyLabel,
  editableRouteAgreement,
  disableStatBoxes,
}) => {
  const dispatch = useDispatch();

  const onDeleteHandler = useCallback(() => {
    dispatch(
      rateSheetStandardTableWrapperActions.tableRows.recordAction(
        routeAgreementId,
        rateSheetTableActions.markPriceAsDeleted(
          rateSheetTableRowState.routeAgreementPriceId
        )
      )
    );
  }, [
    dispatch,
    routeAgreementId,
    rateSheetTableRowState.routeAgreementPriceId,
  ]);

  const onUndeleteHandler = useCallback(() => {
    dispatch(
      rateSheetStandardTableWrapperActions.tableRows.recordAction(
        routeAgreementId,
        rateSheetTableActions.removeDeletedMark(
          rateSheetTableRowState.routeAgreementPriceId
        )
      )
    );
  }, [
    dispatch,
    routeAgreementId,
    rateSheetTableRowState.routeAgreementPriceId,
  ]);

  const onCopyHandler = useCallback(() => {
    dispatch(
      rateSheetStandardTableWrapperActions.tableRows.recordAction(
        routeAgreementId,
        rateSheetTableActions.makeCopyOfRow(
          rateSheetTableRowState.routeAgreementPriceId
        )
      )
    );
  }, [
    dispatch,
    routeAgreementId,
    rateSheetTableRowState.routeAgreementPriceId,
  ]);

  const actionsDisabled = !editableRouteAgreement;

  return (
    <Row>
      <EditRateRowButton
        rateSheetTableRowState={rateSheetTableRowState}
        currencyLabel={currencyLabel}
        routeAgreementId={routeAgreementId}
        routeAgreementPriceId={routeAgreementPriceId}
        editableRouteAgreement={editableRouteAgreement}
        disableStatBoxes={disableStatBoxes}
      />
      <Space />
      <Popover
        placement={"bottom"}
        trigger={"click"}
        disablePadding
        renderTrigger={(props) => (
          <FlatButton
            leftIcon={stenaDots}
            disabled={actionsDisabled}
            {...props}
          />
        )}
      >
        {({ onRequestClose }) => (
          <ActionMenu>
            <ActionMenuItem
              label={"Copy vehicle"}
              onClick={() => {
                onCopyHandler();
                onRequestClose();
              }}
            />
            {rateSheetTableRowState.deleted ? (
              <ActionMenuItem
                label={"Undo delete"}
                onClick={() => {
                  onUndeleteHandler();
                  onRequestClose();
                }}
              />
            ) : (
              <ActionMenuItem
                label={"Delete vehicle"}
                onClick={() => {
                  onDeleteHandler();
                  onRequestClose();
                }}
              />
            )}
          </ActionMenu>
        )}
      </Popover>
    </Row>
  );
};
